module.exports = __webpack_public_path__ + "static/media/right.19c9353c.svg";